import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import moment from 'moment';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import { RecordInfoModel, File } from "@/types/Component";
import { toCamel } from 'snake-camel';

@Component({
    components: {
        Thumbnail
    }
})
export default class RecordInfo extends Vue {
    private currentMenu = 'work'

    @Prop({ default: {
        createdUser: null,
        created: null,
        updatedUser: null,
        updated: null
    }})
    private recordInfo!: RecordInfoModel

    private createdUserImage: File | null = null
    private updatedUserImage: File | null = null
    private apiBaseUrl = '/workers'
    private createdDate = ''
    private updatedDate = ''

    @Watch('recordInfo')
    private check(){
        this.records()
    }
  
    async created() {
        this.records();
    }

    async records(){
        if(this.recordInfo.createdUser && this.recordInfo.createdUser.imageId) {
            this.createdUserImage = await this.getUserImage(this.recordInfo.createdUser.id)
        }
        if(this.recordInfo.updatedUser && this.recordInfo.updatedUser.imageId) {
            this.updatedUserImage = await this.getUserImage(this.recordInfo.updatedUser.id)
        }
        if(this.recordInfo.created) {
            this.createdDate = moment(this.recordInfo.created).format('YYYY/MM/DD HH:mm:ss')
        }
        if(this.recordInfo.updated) {
            this.updatedDate = moment(this.recordInfo.updated).format('YYYY/MM/DD HH:mm:ss')
        }
    }

    async getUserImage(userId: string) {
        return this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${userId}/image`)
        .then((res)=>{
            return toCamel(res) as File
        })
        .catch(()=>{
            return null
        })
    }



}